// extracted by mini-css-extract-plugin
export default {"containerWithArrow":"MainSlat__containerWithArrow--InBU17pgme","containerWithTopArrow":"MainSlat__containerWithTopArrow--ChyzuP4Ysu","container":"MainSlat__container--ZCo_1qOfPR"};